import { makeVar } from "@apollo/client";
import type { DialogProps } from "@dmm-com/rocket-web-ui-library/es6/components/dialog";

type InitialState = {
  isVisible: boolean;
  title: string;
  mainButtonName: string;
  mainButtonLabelText: string;
  isMainButtonDisabled?: boolean;
  onMainButtonAction: () => void;
  description?: string;
  subDescription?: string;
  copyButtonConfig?: DialogProps["copyButtonConfig"];
  radioConfig?: DialogProps["radioConfig"];
  subButtonName?: string;
  subButtonLabelText?: string;
  onSubButtonAction?: () => void;
  isDisabledAnimation?: boolean;
  isCancelButton?: boolean;
  imageSrc?: string;
  onCloseDialogCallback?: () => void;
};

const initialState: InitialState = {
  isVisible: false,
  title: "",
  mainButtonName: "",
  mainButtonLabelText: "",
  isMainButtonDisabled: undefined,
  onMainButtonAction: () => ({}),
  description: "",
  subDescription: "",
  copyButtonConfig: undefined,
  radioConfig: undefined,
  subButtonName: "",
  subButtonLabelText: "",
  onSubButtonAction: undefined,
  isDisabledAnimation: false,
  isCancelButton: false,
  imageSrc: "",
  onCloseDialogCallback: undefined,
};

export const dialogState = makeVar(initialState);

type OpenDialogArgs = {
  title: string;
  mainButtonName: string;
  mainButtonLabelText: string;
  isMainButtonDisabled?: boolean;
  onMainButtonAction: () => void;
  description?: string;
  subDescription?: string;
  copyButtonConfig?: DialogProps["copyButtonConfig"];
  radioConfig?: DialogProps["radioConfig"];
  subButtonName?: string;
  subButtonLabelText?: string;
  onSubButtonAction?: () => void;
  isDisabledAnimation?: boolean;
  isCancelButton?: boolean;
  imageSrc?: string;
  onCloseDialogCallback?: () => void;
};

export const openDialog = (args: OpenDialogArgs) => {
  dialogState({ isVisible: true, ...args });
};

export const closeDialog = () => {
  dialogState({
    isVisible: false,
    title: "",
    mainButtonName: "",
    mainButtonLabelText: "",
    isMainButtonDisabled: undefined,
    onMainButtonAction: () => ({}),
    description: "",
    copyButtonConfig: undefined,
    subButtonName: "",
    subButtonLabelText: "",
    onSubButtonAction: undefined,
    isDisabledAnimation: dialogState().isDisabledAnimation,
    isCancelButton: dialogState().isCancelButton,
    imageSrc: "",
    onCloseDialogCallback: undefined,
  });
};
